import '../scss/style.scss'

import isTouchDevice from 'is-touch-device'
if (isTouchDevice()) {
  document.body.classList.add('touch')
} else {
  //const cursor = new AnimateCursor();
  document.body.classList.add('not-touch')
}

import {initTooltips} from "./components/Tooltips/Tooltips";
initTooltips()